import styled from 'styled-components';

const DataDisplayField = ({ label, value }) => {
  return (
    <StyledField>
      <Label>{label}</Label>
      {value}
    </StyledField>
  );
};

export default DataDisplayField;

const StyledField = styled.div`
  display: flex;
  flex-direction: column;
`;

const Label = styled.div`
  font-size: 0.8em;
`;
